import { AxiosResponse } from 'axios';
import { saveAs } from 'file-saver';
import { FILE_NAME_HEADER } from '@phrospr/lib-models';

export async function downloadFileFromApi({ data, headers }: AxiosResponse, fileExtension = 'pdf') {
    const fileName = headers[FILE_NAME_HEADER] ?? `${new Date().getTime()}.${fileExtension}`;
    if (data instanceof Blob) return saveAs(data, fileName);
    saveAs(await data.blob(), fileName);
}
